"use client";

import { frame, motion, useSpring, vh } from "motion/react";
import { useEffect, useRef } from "react";
import aboutImage from '../aboutme_img.png';
import "../index.css";

export function OpenAbout() {
    return (
        <motion.div
      className="about-container"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ duration: 0.8 }}
    >
      <img src={aboutImage} className="about-image" />

      <div className="about-text font-link">
        <p>
          hiii! my name is Chau, i'm a computer science major at University of
          California, <br />
          Riverside and i love coding and building!
        </p>
        <p>
          when i'm not programming, you can catch me journaling, cuddling with
          my cat, <br />
          or trying to beat my best time at solving a Rubik's cube :p
        </p>
        <p>
          i still have so much to learn and I'm open to exploring new
          opportunities :)
        </p>
      </div>
    </motion.div>
  );
}

export default OpenAbout;